import { generateIconComponent } from './icons.utils';

export const ChevronRightLightIcon = generateIconComponent({
    name: 'ChevronRightLightIcon',
    viewBox: '0 0 24 24',
    path: (
        <path d="M6.26575 24C5.94188 24 5.61801 23.876 5.37005 23.6306C4.87665 23.1347 4.87665 22.3351 5.37005 21.8392L15.2127 11.9991L5.37005 2.15893C4.87665 1.66553 4.87665 0.863446 5.37005 0.370048C5.86598 -0.123349 6.66553 -0.123349 7.16146 0.370048L17.8973 11.1059C18.1326 11.3437 18.2667 11.6651 18.2667 11.9991C18.2667 12.3356 18.1326 12.6569 17.8973 12.8948L7.16146 23.6306C6.9135 23.876 6.58962 24 6.26575 24Z" />
    ),
});
